module.exports = __webpack_public_path__ + "img/cover.fb05981d.jpg";